
export const diffInDays = (from, to) => {
  if (!from || !to) return 0;

  const start = new Date(from);
  const end = new Date(to);

  // Ignore time completely
  const startDate = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const endDate = new Date(end.getFullYear(), end.getMonth(), end.getDate());

  return Math.max(
    Math.round((endDate - startDate) / (1000 * 60 * 60 * 24)),
    0
  );
};

export const calcParkingBreakdown = (movements = [], rate = 0, checkin_date, checkout_date) => {
  console.log("checkin_date",checkin_date)
  console.log("checkout_date",checkout_date)
  const sorted = [...movements]
    .filter((m) => m && m.movement_date)
    .sort((a, b) => new Date(a.movement_date) - new Date(b.movement_date));

  const segments = [];
  let running = 0;
  let total = 0;
  let cursor = checkin_date || (sorted[0] && sorted[0].movement_date);

  sorted.forEach((m) => {
    const days = diffInDays(cursor, m.movement_date);
    if (days > 0 && running > 0) {
      const amount = running * Number(rate) * days;
      segments.push({ from: cursor, to: m.movement_date, vehicles: running, days, amount, current: false });
      total += amount;
    }
    running += m.movement_type === "IN" ? Number(m.vehicle_count || 0) : -Number(m.vehicle_count || 0);
    running = Math.max(running, 0);
    cursor = m.movement_date;
  });

  if (running > 0 && cursor) {
    const finalDays = Math.max(diffInDays(cursor, checkout_date), 1);
    const amount = running * Number(rate) * finalDays;
    segments.push({ from: cursor, to: checkout_date, vehicles: running, days: finalDays, amount, current: true });
    total += amount;
  }
  console.log("segments",segments)

  return { segments, total };
};